module.exports = __webpack_public_path__ + "fa-solid-900.997f6b1819184c54248d.woff";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-solid-900.woff
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-solid-900.woff
// module chunks = styles